import React, { useEffect, useState } from "react";
import CommonList from "../common/CommonList";
import { apiCall, apiCallResponse } from "src/_apiConfig/apiCall";
import Auth from "src/auth";

const EMDBGPaymentList = () => {
  const [bankguaranteelist, setbankguaranteelist] = useState();
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false);
  const [pageLimit, setpageLimit] = useState(0);

  const { authenticated } = Auth();
  // eslint-disable-next-line no-unused-vars
  const [itemPerPage, setItemPerPage] = useState(10);
  const [disabledApproveRej, setdisabledApproveRej] = useState(false);
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage

  const approveBG = async (lotpaymentid, isTransferLotBG, ABSBGPaymentId) => {
    console.log(isTransferLotBG);
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const response = await apiCall(
      "Cheque/ApporveReject",
      "POST",
      header,
      JSON.stringify({
        isApprove: true,
        lotPaymentId: lotpaymentid,
        userId: authenticated.userId,
        isTransferLotBG: isTransferLotBG,
        paymentid: ABSBGPaymentId,
      })
    );

    await response.json();
    if (response.status === 200) {
      alert("Cheque Approved Successfully.");
      getBGList();
    }
  };

  const rejectBG = async (lotpaymentid, isTransferLotBG, ABSBGPaymentId) => {
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const response = await apiCall(
      "Cheque/ApporveReject",
      "POST",
      header,
      JSON.stringify({
        isApprove: false,
        lotPaymentId: lotpaymentid,
        userId: authenticated.userId,
        isTransferLotBG: isTransferLotBG,
        paymentid: ABSBGPaymentId,
      })
    );

    await response.json();
    if (response.status === 200) {
      alert("Cheque Rejected Successfully.");
      getBGList();
    }
  };

  // useEffect(() => {
  //   if (authenticated.role === "CFO" && authenticated.isViewOnly) {
  //     setdisabledApproveRej(true);
  //   } else {
  //     setdisabledApproveRej(false);
  //   }

  //   getBGList(true);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [authenticated]);
  useEffect(() => {
    if (authenticated.role === "CFO" && authenticated.isViewOnly) {
      setdisabledApproveRej(true);
    } else {
      setdisabledApproveRej(false);
    }
   // setloading(true);
    reset();
    getPageCount(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getBGList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit]);

  useEffect(() => {
    if (isSearch) {
      getPageCount();
      getBGList(true);
      //setIsClear(false);
      setIsSearch(false);
      // reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  const reset = () => {
    setpageLimit(0);
  };
  // pagging Disabled  manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  // pagging Disabled Manage
  const paggingManage = (totalRecord, isRecordGet = true) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };
  // get Report List Count
  const getPageCount = async () => {
    if (authenticated) {
      await apiCallResponse(
        `Cheque/BankGuaranteePaymentList?userid=${authenticated.userId}`
      ).then((res) => {
        if (res.success) paggingManage(parseInt(res.data.length) || 0);
        else paggingManage(0, false);
      });
    }
  };
  const getBGList = async (firstRequest) => {
    console.log("get BG List called");
    if (authenticated) {
      paggingDisabled();
    //  setloading(true);

      await apiCallResponse(
        `Cheque/BankGuaranteePaymentList?userid=${authenticated.userId}`
      )
        .then((res) => {
          if (res.success) {
            setbankguaranteelist(res.data);
            if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
              paggingManage(pageCount);
            }
          } else {
            setbankguaranteelist();
            paggingManage(0, false);
          }
        })
        .finally(() => {
        //  setloading(false);
        });
    }
  };

  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitCheck = pageLimit - parseInt(itemPerPage);
    if (pageLimitCheck < 0) {
      pageLimitCheck = 0;
    }
    setpageLimit(pageLimitCheck);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitCheck = pageLimit + parseInt(itemPerPage);
    if (pageLimitCheck >= parseInt(pageCount)) {
      pageLimitCheck = parseInt(pageCount);
      setdisablednext(true);
    }
    setpageLimit(pageLimitCheck);
  };

  //// item per page  onChanage Event
  // const onChangePage = (ev) => {
  //   ev.preventDefault();
  //   setpageLimit(0);
  //   setItemPerPage(ev.target.value);
  //   setIsSearch(true);
  // };
  let fields = [
    // {
    //   key: "tenderId",
    //   _style: { width: "6%" },
    //   label: <div>Tender Id</div>,
    // },
    {
      key: "tenderNo",
      _style: { width: "6%" },
      label: <div>Tender No</div>,
    },
    {
      key: "lotNo",
      _style: { width: "6%" },
      label: <div>Lot No</div>,
    },
    {
      key: "companyName",
      _style: { width: "15%" },
      label: <div>Company Name</div>,
    },
    {
      key: "bidderName",
      _style: { width: "15%" },
      label: <div>Bidder Name</div>,
    },
    {
      key: "emailAddress",
      _style: { width: "15%" },
      label: <div>Email Address</div>,
    },
    {
      key: "bankName",
      _style: { width: "15%" },
      label: <div>Bank Name</div>,
    },
    {
      key: "amount",
      _style: { width: "8%" },
      label: <div>Amount</div>,
    },
    {
      key: "dueDate",
      _style: { width: "8%" },
      label: <div>Last Date</div>,
    },
    {
      key: "viewBG",
      label: "View",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
    {
      key: "approveBG",
      label: "Generate Agreement",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
    {
      key: "rejectBG",
      label: "Reject",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
  ];

  return (
    <CommonList
      items={bankguaranteelist}
      fields={fields}
      listName="Cheque Payment List"
      loading={loading}
      prev={prevButton}
      next={nextButton}
      disabledprev={disabledprev}
      disablednext={disablednext}
      approveBG={approveBG}
      rejectBG={rejectBG}
      disableApproveReject={disabledApproveRej}
    />
  );
};
export default EMDBGPaymentList;
